import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import InfoWindowContent from '@rsos/components/capstone/common/Map/InfoWindow/InfoWindowContent';
import {
  StyledCallPopover,
  StyledPopoverCaret,
} from '@rsos/components/capstone/common/Map/useDeckGL/MapPopover/MapPopover.styles';
import { createWebMercatorViewport } from '@rsos/components/capstone/common/Map/useDeckGL/utils';
import { EMERGENCY_CALLS } from '@rsos/constants/incidentTypes';

/**
 * Custom popover component used for the CRG Map Card only
 * @param {Instance} overlay - Deck.gl overlay instance used with the CRG Map Card
 */
const CallMapPopover = ({ overlay, data }) => {
  const [popoverPosition, setPopoverPosition] = useState(null);
  const basemap = useSelector(state => state.sinatra.ui.basemap);

  const reposition = useCallback(
    (viewState, incidentPopoverNormalized) => {
      const viewport = createWebMercatorViewport(viewState, basemap);
      if (incidentPopoverNormalized) {
        let callLocPosition = [
          incidentPopoverNormalized.longitude,
          incidentPopoverNormalized.latitude,
        ];
        const [x, y] = viewport.project(callLocPosition);

        setPopoverPosition({ x, y: y + 20 }); // + 20 to account for not display call status
      }
    },
    [setPopoverPosition, basemap],
  );

  useEffect(() => {
    if (overlay && data) {
      const viewState = overlay.getViewState();
      reposition(viewState, data);
    }

    if (!data) {
      setPopoverPosition(null);
    }
  }, [data, overlay, reposition]);

  if (popoverPosition && data) {
    return (
      <StyledCallPopover x={popoverPosition?.x} y={popoverPosition?.y}>
        <InfoWindowContent
          type={EMERGENCY_CALLS}
          data={data}
          isInternational={false}
        />
        <StyledPopoverCaret isGoogleMap />
      </StyledCallPopover>
    );
  }

  return null;
};

export default CallMapPopover;
